<template>
  <span>
    <fa-icon
      :icon="[collection, icon]"
      :size="size"
      :spin="spin"
      :pulse="pulse"
      :rotation="rotation"/>
  </span>
</template>

<script>

  export default {
    name: "PimblrIcon",
    props: {
      collection: {type: String, default: 'fal'},
      icon: {type: String, required: true},
      size: {type: String},
      spin: {default: false},
      pulse: {default: false},
      rotation: {default: null},

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ui/Icon.vue